import { productConfig } from './product.config.js'

const product = {
  ...productConfig,
  chatRequiresActiveSubscription: false,
  getIncompleteProfileLabel() {
    return 'Заполни визитку'
  },
  components: {
    home: () => import('./views/home/Home.vue'),
    profile: () => import('./views/profile/UserProfile.vue'),
    profileCard: () => import('./views/profile/ProfilePageProfileCard.vue'),
    faq: () => import('./views/faq/FaqMainPage.vue'),
    onboarding: () => import('./views/onboarding/Onboarding.vue'),
    onwards: () => import('./views/onwards/Onwards.vue'),
    editProfile: () => import('./views/profile/edit/EditProfile.vue'),
    editLookingFor: () => import('./views/profile/edit/EditLookingFor.vue'),
    editNiches: () => import('./views/profile/edit/EditNiches.vue'),
    marketplaceBroadcasts: () => import('./views/study/broadcasts/MarketplaceBroadcasts.vue'),
    marketplaceBroadcastLanding: () => import('./views/study/broadcasts/MarketplaceBroadcastLanding.vue'),
    subscriptionOffer: () => import('@/views/policy/younesis/SubscriptionOffer.vue'),
    privacyPolicy: () => import('@/views/policy/younesis/PrivacyPolicy.vue'),
    informationAdvertisingPolicy: () => import('@/views/policy/younesis/InformationAdvertisingPolicy.vue'),
    userAgreement: () => import('@/views/policy/younesis/UserAgreement.vue'),
    personalDataProcessing: () => import('@/views/policy/younesis/PersonalDataProcessing.vue'),
  },
  assets: {
    favicon: new URL('./assets/images/icons/favicon.svg', import.meta.url).href,
    logo128x58: new URL('./assets/images/logos/logo128x58.png', import.meta.url).href,
    logo186x84: new URL('./assets/images/logos/logo186x84.png', import.meta.url).href,
    poweredBy: new URL('./assets/images/logos/poweredBy.png', import.meta.url).href,
    logoLeadPay128x58: new URL('./assets/images/logos/logo128x58_WithLeadPay.png', import.meta.url).href,
    logoLeadPay186x84: new URL('./assets/images/logos/logo186x84_WithLeadPay.png', import.meta.url).href,
    welcome: new URL('./assets/images/welcome.png', import.meta.url).href,
    welcomeBackground: new URL('../../assets/images/background/younesis_welcome_background.png', import.meta.url).href,
  },
  subscription: {
    displayName: 'Younesis',
    features: [
      {
        title: 'Сообщество и социальный капитал',
        text: 'В чат подписки можно прийти с любым вопросом: сломался трафик, поссорился с экспертом, отдел продаж ушёл одним днём — тебя поймут, поддержат и подскажут, что делать',
        image: new URL('../../views/subscriptions/images/features/younesis/feature_1.png', import.meta.url).href,
      },
      {
        title: 'Насмотренность и инструменты',
        text: 'Дважды в неделю мы берём темы, которые обсуждаются в чате — закон о русификации, блокировки сервисов, нейросети, работа с базой, каскадные воронки и т.д. — приглашаем профи, записываем мастер-класс или проводим эфир. Все материалы в твоём ежедневном доступе в этом приложении',
        image: new URL('../../views/subscriptions/images/features/younesis/feature_2.png', import.meta.url).href,
      },
      {
        title: 'Премиум-функции',
        text: 'Добавь статус к своей аватарке, чтобы другие сразу понимали, с чем к тебе можно обратиться – взять консультацию, пригласить в проект, предложить партнёрство и т.д. А ещё профили с премиальным статусом первыми выдаются в поиске по ключевым словам',
        image: new URL('../../views/subscriptions/images/features/younesis/feature_3.png', import.meta.url).href,
      },
    ],
    currentFeatures: [
      'Более 500 участников ежедневно в нетворкинге на платформе',
      'Подборки проверенных специалистов с твёрдыми цифрами и результатами',
      'Календарь мероприятий со всеми актуальными событиями на рынке',
    ],
    includedFeatures: [],
  },
  desktopRoutes: [
    {
      path: '/desktop',
      name: 'Desktop',
      component: () => import('@/desktop/layouts/BaseDesktopLayout.vue'),
      meta: {
        layout: 'HomeLayout',
        onboardingIsAllowed: true,
        isDesktop: true,
        isPublic: true,
        allowAuth: true,
      },
      children: [
        {
          path: '',
          redirect: { name: 'DesktopBroadcasts' },
        },
        {
          path: 'auth',
          name: 'DesktopAuth',
          meta: {
            layout: 'EmptyLayout',
            disableRedirect: true,
          },
          component: () => import('@/desktop/views/auth/DesktopAuth.vue'),
        },
        {
          path: 'broadcasts',
          name: 'DesktopBroadcastsMain',
          meta: {
            navigationTab: 'broadcasts',
          },
          children: [
            {
              path: '',
              name: 'DesktopBroadcasts',
              component: () => import('@/desktop/views/broadcasts/DesktopBroadcasts.vue'),
            },
            {
              path: 'study/:userCourseId',
              name: 'DesktopBroadcast',
              props: true,
              component: () => import('@/desktop/views/broadcasts/DesktopBroadcast.vue'),
            },
          ],
        },
        {
          path: 'master-classes',
          name: 'DesktopMasterClassesMain',
          meta: {
            navigationTab: 'master-classes',
          },
          children: [
            {
              path: '',
              name: 'DesktopMasterClasses',
              component: () => import('@/desktop/views/master-classes/DesktopMasterClasses.vue'),
            },
            {
              path: 'study/:userCourseId',
              name: 'DesktopMasterClassStudy',
              props: true,
              component: () => import('@/desktop/views/study/DesktopStudyLesson.vue'),
            },
          ],
        },
        {
          path: 'courses',
          name: 'DesktopCoursesMain',
          meta: {
            navigationTab: 'courses',
          },
          children: [
            {
              path: '',
              name: 'DesktopCourses',
              component: () => import('@/desktop/views/courses/DesktopCourses.vue'),
            },
            {
              path: 'study/:userCourseId',
              name: 'DesktopStudyLesson',
              props: true,
              component: () => import('@/desktop/views/study/DesktopStudyLesson.vue'),
            },
          ],
        },
        {
          path: 'favorites',
          name: 'DesktopFavoritesMain',
          meta: {
            navigationTab: 'favorites',
          },
          children: [
            {
              path: '',
              name: 'DesktopFavorites',
              component: () => import('@/desktop/views/favorites/DesktopFavorites.vue'),
            },
            {
              path: 'study/:userCourseId',
              name: 'DesktopFavoritesStudy',
              props: true,
              component: () => import('@/desktop/views/study/DesktopStudyLesson.vue'),
            },
          ],
        },
        {
          path: 'my-courses/:pathMatch(.*)*',
          redirect: to => {
            const rest = to.params.pathMatch
            const suffix = Array.isArray(rest) ? rest.join('/') : (rest || '')
            return {
              path: `/desktop/courses${suffix ? `/${suffix}` : ''}`,
              query: to.query,
              hash: to.hash,
            }
          },
        },
      ],
    },
  ],
  broadcastRoutes: [],
  profileEditRoutes: [],
  myRoutes: [],
  hideNavBarRouteNames: [],
  resolvePolicies() {
    return {
      InformationAdvertisingPolicy: 'https://younesis.com/mailing',
      PersonalDataProcessing: 'https://younesis.com/persdata',
      PrivacyPolicy: 'https://younesis.com/police_main',
      SubscriptionOffer: 'https://younesis.com/oferta_app',
      UserAgreement: 'https://younesis.com/agreement',
    }
  },
}

export { product }
